import React from "react";

import Grid from "@material-ui/core/Grid";
import FormHelperText from "@material-ui/core/FormHelperText";

import CheckboxListQuestion from "../../../../../question/CheckboxListQuestion/CheckboxListQuestion";
import AggregatedDepotsSwitch
  from "../../../../../../../../../CustomerDashboardV2/components_v2/AggregatedDepotsSwitch/AggregatedDepotsSwitch";

import useStyles from "./styles";


const SelectAspectsV2 = ({onAnswerChange, question}) => {
  const classes = useStyles();

  const options = question.config.choices;

  const allValues = React.useMemo(() => {
    return options.map(option => option.uid);
  }, [options]);

  const isAllSelected = (question.answer || []).length === allValues.length;

  const selectAllChange = (checked) => {
    question.error = null;
    onAnswerChange(question.uid, checked ? [...allValues] : []);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <div className={classes.title}>{question.question_text}</div>
        {question.error && (
          <FormHelperText
            error={true}
            classes={{
              error: classes.errorContainer
            }}>{question.error}</FormHelperText>
        )}
      </Grid>
      <Grid item xs={12}>
        {question.question_info}
      </Grid>
      <Grid item xs={12}>
        <Grid container justify={'flex-end'}>
          <AggregatedDepotsSwitch
            value={isAllSelected}
            title={'Alle auswählen'}
            onChange={selectAllChange}
          />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <CheckboxListQuestion
          question={question}
          onAnswerChange={onAnswerChange}
          useCard
          noLabel
        />
      </Grid>
    </Grid>
  );
};


export default SelectAspectsV2;
